import './infoCircle.scss'
import classNames from 'classnames'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const InfoCircle = ({ value, isActive, onClick, className, ...props }) => {
  const onCircleClick = () => {
    onClick?.(value)
  }

  return (
    <button
      type='button'
      onClick={onCircleClick}
      className={classNames('info-circle-container', { active: isActive, className })}
      {...props}>
      {value}
    </button>
  )
}

export default InfoCircle
